// Cart drawer + AJAX add-to-cart
(function(){
  const $ = (s,c=document)=>c.querySelector(s);
  const $$ = (s,c=document)=>Array.from(c.querySelectorAll(s));

  async function refreshCart(){
    const res = await fetch('/cart.js',{headers:{Accept:'application/json'}});
    const cart = await res.json();
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));
    const c = document.querySelector('[data-cart-count]');
    if(c){ c.textContent = cart.item_count; c.style.display = cart.item_count>0?'inline-flex':'none'; }
    renderDrawer(cart);
    return cart;
  }

  function formatMoney(cents){
    const v = (cents/100).toFixed(2);
    return (window.Shopify && Shopify.currency && Shopify.currency.active === 'INR') ? '₹'+v : (window.Shopify?.currency?.active||'')+' '+v;
  }

  function renderDrawer(cart){
    const body = document.querySelector('[data-cart-body]');
    const foot = document.querySelector('[data-cart-foot]');
    if(!body) return;
    if(cart.item_count===0){
      body.innerHTML = '<p style="padding:40px 0;text-align:center;color:rgba(0,0,0,.5)">Your bag is empty.</p>';
      foot.innerHTML = '<a href="/collections/all" class="btn" style="width:100%;justify-content:center">Continue shopping</a>';
      return;
    }
    body.innerHTML = cart.items.map(i => `
      <div class="cart-item" data-key="${i.key}">
        <img src="${i.image}" alt="${i.title}">
        <div>
          <div class="name">${i.product_title}</div>
          ${i.variant_title && i.variant_title!=='Default Title' ? '<div style="font-size:12px;color:rgba(0,0,0,.5);margin-top:4px">'+i.variant_title+'</div>' : ''}
          <div class="qty" style="margin-top:10px">
            <button data-qty-dec>−</button>
            <input value="${i.quantity}" data-qty type="text" readonly>
            <button data-qty-inc>+</button>
          </div>
        </div>
        <div style="text-align:right">
          <div>${formatMoney(i.final_line_price)}</div>
          <button data-remove style="font-size:11px;letter-spacing:.15em;text-transform:uppercase;color:rgba(0,0,0,.5);margin-top:8px">Remove</button>
        </div>
      </div>
    `).join('');
    foot.innerHTML = `
      <div style="display:flex;justify-content:space-between;font-size:14px;letter-spacing:.05em;margin-bottom:16px">
        <span style="text-transform:uppercase;letter-spacing:.2em">Subtotal</span>
        <span>${formatMoney(cart.total_price)}</span>
      </div>
      <a href="/checkout" class="btn" style="width:100%;justify-content:center">Checkout</a>
    `;
    body.querySelectorAll('.cart-item').forEach(el=>{
      const key = el.dataset.key;
      const qty = parseInt(el.querySelector('[data-qty]').value,10);
      el.querySelector('[data-qty-inc]').addEventListener('click',()=>changeItem(key,qty+1));
      el.querySelector('[data-qty-dec]').addEventListener('click',()=>changeItem(key,Math.max(0,qty-1)));
      el.querySelector('[data-remove]').addEventListener('click',()=>changeItem(key,0));
    });
  }

  async function changeItem(key,quantity){
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
    refreshCart();
  }

  function openCart(){ document.querySelector('.drawer')?.classList.add('open'); document.querySelector('.drawer-backdrop')?.classList.add('open'); }
  function closeCart(){ document.querySelector('.drawer')?.classList.remove('open'); document.querySelector('.drawer-backdrop')?.classList.remove('open'); }

  document.addEventListener('click',(e)=>{
    if(e.target.closest('[data-open-cart]')){ e.preventDefault(); openCart(); }
    if(e.target.closest('[data-close-cart]')){ e.preventDefault(); closeCart(); }
  });

  // AJAX add-to-cart
  document.addEventListener('submit', async (e)=>{
    const form = e.target.closest('form[action^="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const orig = btn?.textContent;
    if(btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
    try{
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}});
      if(!res.ok) throw new Error('add failed');
      await refreshCart();
      openCart();
    } catch(err){ alert('Could not add to bag'); }
    if(btn){ btn.disabled = false; btn.textContent = orig; }
  });

  // Init count on load
  document.addEventListener('DOMContentLoaded', refreshCart);

  // Product page: gallery + variant switch
  document.addEventListener('click',(e)=>{
    const t = e.target.closest('.product-media__thumbs button');
    if(!t) return;
    const src = t.querySelector('img')?.src;
    const main = document.querySelector('.product-media__main img');
    if(src && main){ main.src = src; }
    document.querySelectorAll('.product-media__thumbs button').forEach(b=>b.classList.remove('active'));
    t.classList.add('active');
  });
})();
